// src/pages/account/SubscriptionSuccess.js
import React, { useState, useContext } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { NotificationContext } from '../../context/NotificationContext';
import { BASE_URL } from '../../utils/config';
import './SubscriptionSuccess.css';
import { useLanguage } from '../../hooks/useLanguage';

const SubscriptionSuccess = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { addNotification } = useContext(NotificationContext);
  const [isResending, setIsResending] = useState(false);

  const lang = useLanguage();
  const email = location.state?.email || t('subscriptionSuccessPage.yourEmailAddress');
  const bonusAwarded = location.state?.bonusAwarded; // Get the bonus points

  const handleResendVerification = async () => {
    if (!email || email === t('subscriptionSuccessPage.yourEmailAddress')) {
      addNotification(t('subscriptionSuccessPage.noEmailError'), 'error');
      return;
    }
    setIsResending(true);
    try {
      const response = await fetch(`${BASE_URL}/authUser/request-verification-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        addNotification(t('subscriptionSuccessPage.resendSuccess', { email }), 'success');
      } else {
        throw new Error(data.message || t('subscriptionSuccessPage.resendFailError'));
      }
    } catch (error) {
      addNotification(t('subscriptionSuccessPage.genericError', { message: error.message }), 'error');
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="subscription-success-page-container">
      <meta name="robots" content="noindex" />
      <div className="subscription-success-container">
        <h2>{t('subscriptionSuccessPage.title')}</h2>
        <p className="success-icon">
          <i className="fas fa-check-circle"></i>
        </p>
        {bonusAwarded > 0 && (
          <p className="bonus-message">
            <Trans i18nKey="subscriptionSuccessPage.bonusMessage" values={{ bonusAwarded }}>
              Thank you for joining us! To show our appreciation, we've added a welcome gift of <strong>{{ bonusAwarded }} credit points</strong> to your account.
            </Trans>
          </p>
        )}
        <p>
          <Trans i18nKey="subscriptionSuccessPage.linkSent" values={{ email }}>
            A verification link has been sent to <strong>{{ email }}</strong>.
          </Trans>
        </p>
        <p>{t('subscriptionSuccessPage.checkInbox')}</p>
        <div className="resend-verification-section">
          <p>{t('subscriptionSuccessPage.didNotReceive')}</p>
          <button onClick={handleResendVerification} disabled={isResending} className="resend-btn">
            {isResending ? t('subscriptionSuccessPage.resendingButton') : t('subscriptionSuccessPage.resendButton')}
          </button>
        </div>
        <p className="close-tab-notice">{t('subscriptionSuccessPage.closeTab')}</p>
        <div className="success-actions">
          <p>
            <Trans i18nKey="subscriptionSuccessPage.loginPrompt">
              Once verified, you can <Link to={`/${lang}/login`}>log in here</Link>.
            </Trans>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
